//@ts-nocheck

'use client'

import React from "react"

import * as S from './Testimonial.style'

import { Container, Row, Col, SpacerBase } from '../../atoms/GridSystem'
import Icon from '../../atoms/Icon/Icon.component'
import { Heading, Paragraph } from "../../atoms/Typography/Typography.component"

import Image from 'next/image'
import Text from '../Text/Text.component'

const Testimonial = ({
  variant = 'image',
  quote,
  author,
  colorScheme,
  image,
  caption,
  withBackground
}) => {

  return (
    <S.Testimonial>
      <Container>
        <Row>
          <Col xs={12} lg={5}>
            <S.TestimonialAuthorWrapper>
              <S.TestimonialAuthor colorScheme={colorScheme} withBackground={withBackground}>
                <S.TestimonialAuthorImage>
                  <Image src={author.image.src} alt={author.image.alt} fill />
                </S.TestimonialAuthorImage>
                <SpacerBase xs={2} />
                { author?.name ? (
                  <Heading content={author.name} typo={'headingXS'} as={'h2'} weight={'medium'} />
                ) : null}
                { author?.role ? (
                  <Paragraph content={author.role} typo={'headingXS'} />
                ) : null}
              </S.TestimonialAuthor>
              <S.TestimonialAuthorIcon>
                <Icon name='leaf-diagonal' useIconColor />
              </S.TestimonialAuthorIcon>
            </S.TestimonialAuthorWrapper>
          </Col>
          <Col xs={12} lg={7}>
            { variant === 'image' ? (
              <>
                <S.TestimonialImageWrapper>
                  <Image src={image.src} alt={image.alt} fill />
                </S.TestimonialImageWrapper>
                { caption ? (
                  <S.TestimonialImageCaption colorScheme={colorScheme} withBackground={withBackground}>
                    <SpacerBase xs={2} />
                    <Paragraph content={caption} typo={'headingXS'} />
                  </S.TestimonialImageCaption>
                ) : null}
              </>
            ) : (
              <S.TestimonialQuoteWrapper>
                <Text type="TextQuote" colorScheme={colorScheme} quote={quote} author={author} />
              </S.TestimonialQuoteWrapper>
            )}
          </Col>
        </Row>
      </Container>
    </S.Testimonial>
  )
}

export default Testimonial
